import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useStyles } from "Styles";

export default function LoadingScreen(props) {
	const classes = useStyles();

	return (
		<div>
			<Backdrop sx={{ zIndex: 199999 }} className={classes.backdrop} open={props.open}>
				<CircularProgress color="inherit" />
			</Backdrop>
		</div>
	);
}
